module.exports = __webpack_public_path__ + "img/cooperation10.da04b929.png";